import { AsyncReturnType } from "type-fest";

import { BillingService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof BillingService.createPaymentIntent>[0];
type Data = AsyncReturnType<typeof BillingService.createPaymentIntent>;
type Error = unknown;

export const useCreatePaymentIntent = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    BillingService.createPaymentIntent,
    options
  );

  return result;
};
